import { Injectable } from '@angular/core';
import { timer, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
export enum SwalType {
    none,
    operation,
    error,
}

@Injectable({
    providedIn: 'root',
})
export class AlertUtility {
    /**
     * Return a configured swal options for SweetAlert2 boxes.
     *
     * @param type one from none | operation | error, to select the correct configuration.
     * @param isSuccess SwalType.operation -> condition to evaluate.
     * @param message message to show into alert box.
     * @param title title of alert box.
     * @param resultTrue SwalType.operation -> Message for true condition.
     * @param resultFalse SwalType.operation -> Message for false condition.
     */
    public getSwalData(type: SwalType, isSuccess: boolean, message: string, title: string = '', resultTrue: string = '', resultFalse: string = ''): any {
        let result: any;

        switch (type) {
            case SwalType.error:
                result = {
                    title: title,
                    text: message,
                    type: '',
                    confirmButtonClass: 'btn btn-error',
                    buttonsStyling: false,
                };
                break;
            case SwalType.operation:
                result = {
                    title: title,
                    text: `${message} ${isSuccess ? resultTrue + '.' : 'non ' + resultFalse + '.'}`,
                    type: isSuccess ? 'success' : 'error',
                    confirmButtonClass: 'btn ' + (isSuccess ? 'btn-success' : 'btn-error'),
                    buttonsStyling: false,
                };
                break;
            case SwalType.none:
                result = {
                    title: title,
                    text: message,
                    type: 'info',
                    confirmButtonClass: 'btn btn-error',
                    buttonsStyling: false,
                };
                break;
        }

        return result;
    }
}

@Injectable({
    providedIn: 'root',
})
export class ConversionUtility {
    /**
     * Convert 1 '1' and 'true'to true and 0 '0' 'false' null and undefined to false
     * @param value string value to convert into boolean.
     */
    toBoolean(value: string | number | boolean | null | undefined): boolean {
        if (value === 'true') {
            return true;
        }

        return typeof value === 'string'
            ? !!+value // we parse string to integer first
            : !!value;
    }
}

@Injectable({
    providedIn: 'root',
})
export class LocalStorageUtility {
    /**
     * Extract the complete key from localsstorage by partial key name.
     * @param keyFinder parts of key name to find.
     * return value of localstorage key.
     */
    getKeyByName(keyFinder: string): string {
        let keyFound: string;
        const keys = Object.keys(localStorage);

        keys.forEach((key) => {
            if (key.indexOf(keyFinder) >= 0) {
                keyFound = key;
            }
        });

        return keyFound || '';
    }

    /**
     * Extract the value from localsstorage by partial key name.
     * @param keyFinder parts of key name to find.
     * return value of localstorage key.
     */
    getValueByName(keyFinder: string): string {
        let keyFound: string;
        const keys = Object.keys(localStorage);

        keys.forEach((key) => {
            if (key.indexOf(keyFinder) >= 0) {
                keyFound = localStorage.getItem(key);
            }
        });

        return keyFound || '';
    }
}

@Injectable({
    providedIn: 'root',
})
export class TimedUtility {
    /**
     *
     * @param startAfter
     * @param repeatEvery
     * @param method
     */
    static startTimer(startAfter: number = 1000, repeatEvery: number = 1000, method: Function): Subscription {
        let subscription: Subscription;

        const source = timer(startAfter, repeatEvery);
        subscription = source.subscribe((val) => {
            if (method != null) method();
        });

        return subscription;
    }

    static stopTimer(subscription: Subscription) {
        if (subscription != null) {
            subscription.unsubscribe();
            if (environment.canLogConsole) {
                console.log('Ping timer rilasciato.');
            }
        }
    }
}
